import React, { useEffect, useState } from "react";
import { api, resolveMediaUrl } from "../lib/api";

const fallbackBanner = { _id: "fallback", image: { url: "/banner.png", alt: "St. Xavier's Public School Bela" } };

const HeroBanner = () => {
  const [banners, setBanners] = useState([fallbackBanner]);
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    let active = true;
    api.activeBanners()
      .then((response) => {
        if (!active) return;
        const items = Array.isArray(response.data) ? response.data.filter((item) => item.image?.url) : [];
        if (items.length) setBanners(items);
      })
      .catch(() => {});
    return () => { active = false; };
  }, []);

  useEffect(() => {
    if (banners.length < 2) return undefined;
    const timer = window.setInterval(() => setCurrent((index) => (index + 1) % banners.length), 5000);
    return () => window.clearInterval(timer);
  }, [banners.length]);

  useEffect(() => {
    if (current >= banners.length) setCurrent(0);
  }, [banners.length, current]);

  const banner = banners[current] || fallbackBanner;

  return (
    <div className="relative w-full overflow-hidden">
      <img
        src={resolveMediaUrl(banner.image.url)}
        alt={banner.image.alt || "School Banner"}
        className="w-full h-auto block"
      />
      <div className="absolute inset-0 bg-black/20" />
      {banners.length > 1 && (
        <div className="absolute bottom-3 left-1/2 flex -translate-x-1/2 gap-2">
          {banners.map((item, index) => (
            <button
              key={item._id || index}
              type="button"
              onClick={() => setCurrent(index)}
              aria-label={`Show banner ${index + 1}`}
              className={`h-2.5 rounded-full transition-all ${index === current ? "w-7 bg-white" : "w-2.5 bg-white/60"}`}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default HeroBanner;
